import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function UserCoverEdit({ icon, text = '', className = '' }) {
  return (
    <div className={`user-cover__edit ${className}`}>
      <Icon type={['far', `${icon}`]} notSpaced />
      {text
        && <span>{text}</span>
      }
    </div>
  )
}

UserCoverEdit.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
}

export default UserCoverEdit
